export default __webpack_public_path__ + "static/media/arrow.e67981ce.svg";